"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Menu = _interopRequireDefault(require("./MenuV2/Menu"));
var _MenuLogo = _interopRequireDefault(require("./MenuV2/MenuLogo"));
var _MenuItemsList = require("./MenuV2/MenuItemsList");
var _excluded = ["menuItems", "hasSearch", "whiteLabel"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AlLogoIcon = function AlLogoIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, "        ", /*#__PURE__*/_react["default"].createElement("title", null, "airportlabs-logo-new"), "    ", /*#__PURE__*/_react["default"].createElement("desc", null, "Created with Sketch."), "    ", /*#__PURE__*/_react["default"].createElement("defs", null), "    ", /*#__PURE__*/_react["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, "        ", /*#__PURE__*/_react["default"].createElement("g", {
    id: "airportlabs-logo-new",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, "            ", /*#__PURE__*/_react["default"].createElement("polyline", {
    id: "Shape",
    points: "87.441 49.403 82.473 61.102 113.337 61.102 118.303 49.403"
  }), "            ", /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Shape",
    points: "80.956 61.102 73.397 49.403 80.452 32.739 97.51 22.055 85.921 49.403"
  }), "            ", /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Shape",
    points: "5.875 49.403 0.909 61.102 32.359 61.102 98.499 19.773 106.714 0.415 28.319 49.403"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.708,82.481 L8.929,79.698 L4.291,79.698 L3.51,82.481 L1,82.481 L5.217,68.419 L8,68.419 L12.217,82.481 L9.708,82.481 Z M6.608,70.905 L4.754,77.633 L8.466,77.633 L6.608,70.905 Z",
    id: "Shape"
  }), "            ", /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-path",
    x: "13.633",
    y: "68.419",
    width: "2.318",
    height: "14.062"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.125,82.481 L22.724,77.166 L20.974,77.166 L20.974,82.481 L18.654,82.481 L18.654,68.419 L23.503,68.419 C25.948,68.419 27.637,70.167 27.637,72.761 C27.637,75.205 26.265,76.43 24.999,76.767 L27.74,82.481 L25.125,82.481 Z M25.231,72.783 C25.231,71.391 24.43,70.465 23.166,70.465 L20.976,70.465 L20.976,75.1 L23.166,75.1 C24.43,75.1 25.231,74.173 25.231,72.783 Z",
    id: "Shape"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.937,82.481 L29.937,68.419 L34.723,68.419 C37.505,68.419 38.897,70.441 38.897,72.782 C38.897,75.143 37.483,77.145 34.723,77.145 L32.257,77.145 L32.257,82.48 L29.937,82.48 L29.937,82.481 Z M36.515,72.783 C36.515,71.412 35.712,70.465 34.447,70.465 L32.257,70.465 L32.257,75.1 L34.447,75.1 C35.712,75.1 36.515,74.173 36.515,72.783 Z",
    id: "Shape"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.273,75.459 C40.273,71.324 42.337,68.186 45.922,68.186 C49.508,68.186 51.595,71.325 51.595,75.459 C51.595,79.592 49.508,82.733 45.922,82.733 C42.337,82.734 40.273,79.592 40.273,75.459 M49.192,75.459 C49.192,72.506 48.032,70.254 45.922,70.254 C43.814,70.254 42.654,72.506 42.654,75.459 C42.654,78.39 43.813,80.666 45.922,80.666 C48.032,80.667 49.192,78.39 49.192,75.459",
    id: "Shape"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.242,82.481 L57.839,77.166 L56.089,77.166 L56.089,82.481 L53.77,82.481 L53.77,68.419 L58.618,68.419 C61.065,68.419 62.752,70.167 62.752,72.761 C62.752,75.205 61.382,76.43 60.118,76.767 L62.858,82.481 L60.242,82.481 Z M60.347,72.783 C60.347,71.391 59.546,70.465 58.283,70.465 L56.089,70.465 L56.089,75.1 L58.283,75.1 C59.546,75.1 60.347,74.173 60.347,72.783 Z",
    id: "Shape"
  }), "            ", /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Shape",
    points: "67.228 82.481 67.228 70.464 63.979 70.464 63.979 68.417 72.769 68.417 72.769 70.464 69.545 70.464 69.545 82.481"
  }), "            ", /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Shape",
    points: "75.939 82.481 75.939 68.417 78.764 68.417 78.764 79.991 83.51 79.991 83.51 82.481"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.767,82.481 L92.115,79.993 L87.75,79.993 L87.075,82.481 L84.018,82.481 L88.235,68.419 L91.63,68.419 L95.826,82.481 L92.767,82.481 Z M89.92,71.391 L88.299,77.506 L91.568,77.506 L89.92,71.391 Z",
    id: "Shape"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M97.053,82.479 L97.053,68.419 L102.891,68.419 C105.421,68.419 106.623,70.084 106.623,72.002 C106.623,73.753 105.633,74.913 104.345,75.227 C105.78,75.459 106.856,76.937 106.856,78.663 C106.856,80.815 105.652,82.479 103.083,82.479 L97.053,82.479 Z M103.736,72.487 C103.736,71.558 103.228,70.905 102.219,70.905 L99.878,70.905 L99.878,74.089 L102.219,74.089 C103.228,74.088 103.736,73.458 103.736,72.487 Z M103.967,78.285 C103.967,77.315 103.399,76.556 102.322,76.556 L99.878,76.556 L99.878,79.994 L102.322,79.994 C103.375,79.993 103.967,79.381 103.967,78.285 Z",
    id: "Shape"
  }), "            ", /*#__PURE__*/_react["default"].createElement("path", {
    d: "M107.954,80.899 L109.327,78.708 C110.107,79.593 111.349,80.226 112.741,80.226 C114.027,80.226 114.681,79.529 114.681,78.665 C114.681,76.177 108.378,77.063 108.378,72.298 C108.378,70.085 110.107,68.187 113.016,68.187 C114.745,68.187 116.22,68.755 117.295,69.747 L115.966,71.897 C115.123,71.074 114.027,70.696 112.951,70.696 C111.919,70.696 111.265,71.287 111.265,72.13 C111.265,74.343 117.547,73.713 117.547,78.433 C117.547,80.881 115.88,82.735 112.76,82.735 C110.632,82.733 109.073,82.038 107.954,80.899",
    id: "Shape"
  }), "        "), "    "));
};
AlLogoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "119px",
  height: "83px",
  viewBox: "0 0 119 83",
  version: "1.1"
};
var propTypes = {
  /** An array of menu items */
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(_MenuItemsList.menuItemShape)),
  /** Menu has search field */
  hasSearch: _propTypes["default"].bool,
  /** Menu as logout button */
  hasLogoutButton: _propTypes["default"].bool,
  /** The image source and description for white-labeling or false if no logo */
  whiteLabel: _propTypes["default"].shape({
    src: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
    alt: _propTypes["default"].string
  })
};
exports.propTypes = propTypes;
var RealtimeMenuLogo = function RealtimeMenuLogo(props) {
  return /*#__PURE__*/_react["default"].createElement(_MenuLogo["default"], _extends({
    icon: AlLogoIcon,
    pV: "s",
    color: "menuText",
    mB: "base"
  }, props));
};
var RealtimeMenu = function RealtimeMenu(_ref) {
  var menuItems = _ref.menuItems,
    hasSearch = _ref.hasSearch,
    whiteLabel = _ref.whiteLabel,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Menu["default"], _extends({
    logo: RealtimeMenuLogo,
    menuItems: menuItems,
    hasSearch: hasSearch,
    hasLogoutButton: false,
    whiteLabel: whiteLabel
  }, other));
};
RealtimeMenu.propTypes = propTypes;
var _default = RealtimeMenu;
exports["default"] = _default;